const paymentinstEN = `### Payment Instructions - Hang Seng Bank Ltd (恆生銀行)
#### 🔹 Method 1: Bank Transfer 
Bank Name:Hang Seng Bank Ltd (恆生銀行)

Account No.: 769-305426-883 

Payee Name: Mutual Insurance Consultants Co.

#### 🔹 Method 2: FPS
FPS ID: 160318267

FPS Name: Mutual Insurance Consultants Co.

Please upload the transction proof for further processing

**Ensure your proof shows**:  
  - *Transaction ID/Reference #*  
  - *Date & Amount*  
  - *Sender/Receiver details* (partially redacted for privacy)  
  - *Bank/Platform name* (e.g., bank statement snippet)
`;

export default paymentinstEN;